import React, { useState, useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import CardContacto from "./CardContacto.jsx";
import ButtonGroup from "../../../../Components/Asesores/ButtonGroup.jsx"
import TabsWithAnimatedButtons from "./TabsWithAnimatedButtons"

const ActividadDelAsesor =
    ({
        getReporteActividadAsesor,
        selectedAsesor,
        user
    }) => {
        const scrollContainerRef = useRef(null);
        const [loading, setLoading] = useState(false);
        const [verMas, setVerMas] = useState(false);
        const [reporte, setReporte] = useState([]);
        const [selectedContact, setSelectContact] = useState();
        const [currentPage, setCurrentPage] = useState(1);
        const [totalPages, setTotalPages] = useState(1);
        const [selectedOptions, setSelectedOptions] = useState(1);
        const [pendientesCount, setPendientesCount] = useState(0);
        const [sinRespuestaCount, setSinRespuestaCount] = useState(0);
        const [enSeguiminetoCount, setEnSeguimientoCount] = useState(0);
        const [contactadosCount, setContactadosCount] = useState(0);
        const [clientesCount, setClientesCount] = useState(0);
        const [refresh1, setRefresh] = useState(null);
        const [selectedDate, setSelectedDate] = useState(new Date());
        const [click, setClick] = useState();
        const [periodoReporte, setPeriodoReporte] = useState("Dia");
        const [activeTab, setActiveTab] = useState("Dia");

        useEffect(() => {
            setReporte([])
            setRefresh(selectedOptions)
        }, [selectedOptions])
        const calcularStatus = () => {
            if (selectedOptions === 1) {
                return null

            }
            if (selectedOptions === 2) {
                return "No Contactado"

            }
            if (selectedOptions === 3) {
                return "Sin Respuesta"

            }
            if (selectedOptions === 4) {
                return "En Seguimiento"

            }
            if (selectedOptions === 5) {
                return "Cliente"

            }
            if (selectedOptions === 6) {
                return "Contactado"

            }
        }
        const getInfoReporte = async (selectedAsesor, currentPageAux, selectedDate) => {
            setLoading(true)
            const statusSolicitud = calcularStatus()
            getReporteActividadAsesor({
                userId: selectedAsesor.id,
                status: statusSolicitud,
                page: currentPageAux ? currentPageAux : currentPage,
                fecha: selectedDate
            }).then((res) => {
                if (res?.status === 200) {
                    if (currentPageAux) {
                        setCurrentPage(currentPageAux)
                    }
                    let reporteAux = [...reporte, ...res.data.contacts]
                    setReporte(reporteAux)
                    setTotalPages(res.data.totalPages)
                    setPendientesCount(res.data.contactCounts.pendientes || 0)
                    setSinRespuestaCount(res.data.contactCounts.sinRespuesta || 0)
                    setEnSeguimientoCount(res.data.contactCounts.seguimiento || 0)
                    setContactadosCount(res.data.contactCounts.contactado || 0)
                    setClientesCount(res.data.contactCounts.cliente || 0)
                    setLoading(false)
                    setVerMas(false)
                } else {
                    setLoading(false)
                }
            })
        }
        useEffect(() => {
            setLoading(true)
            getInfoReporte(selectedAsesor, 1, null)
        }, [refresh1]);

        useEffect(() => {
            setLoading(true)
            getInfoReporte(selectedAsesor, null, selectedDate)
        }, [currentPage, selectedDate]);

        const siguientePagina = () => {
            setCurrentPage(currentPage + 1)
        }

        const visibleVerMas = (currentPage, totalPages) => {
            if (currentPage < totalPages) {
                console.log("ES TRUE")
                setVerMas(true);
            } else {
                setVerMas(false)
            }
        };

        useEffect(() => {
            const scrollContainer = scrollContainerRef.current;
            if (!scrollContainer) return; // Check if the ref is null
            const handleScroll = () => {
                console.log(scrollContainer.scrollHeight,
                    parseInt(scrollContainer.scrollTop),
                    scrollContainer.clientHeight)
                if (scrollContainer.scrollHeight - parseInt(scrollContainer.scrollTop) === scrollContainer.clientHeight) {

                    visibleVerMas(currentPage, totalPages);
                }
            };
            scrollContainer.addEventListener('scroll', handleScroll);
            return () => {
                scrollContainer.removeEventListener('scroll', handleScroll);
            };
        }, [currentPage, totalPages]);


        return (
            <>

                <b>Esta sin terminar lo unico que anda bien en la parte de los contadores.</b>
                <TabsWithAnimatedButtons
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />


                <ButtonGroup
                    user={selectedAsesor}
                    selectedDate={selectedDate}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    selectedButton={selectedOptions}
                    setSelectedOption={setSelectedOptions}
                    pendientesCount={pendientesCount}
                    sinRespuestaCount={sinRespuestaCount}
                    // enSeguiminetoCount={enSeguiminetoCount}
                    contactadosCount={contactadosCount}
                    clientesCount={clientesCount}
                />


                <ScrollContainer ref={scrollContainerRef}>
                    {reporte.length > 0 ?
                        reporte.map((data, index) => (
                            <CardContacto
                                key={data.id + index}
                                contact={data}
                                click={click}
                                setClick={setClick}
                                setSelectContact={setSelectContact}
                                selectedContact={selectedContact}

                            />
                        ))
                        : null

                    }

                </ScrollContainer>
                {
                    verMas ?
                        <BtnVerMas onClick={siguientePagina}>
                            Ver mas
                        </BtnVerMas>
                        : null
                }
            </>
        )
    }
export default ActividadDelAsesor;

const BtnVerMas = styled.div`
    width: -webkit-fill-available;
    padding:0px 8px;
    border:solid 2px #092a3f;
    border-radius:8px; 
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    height: 34px;
    color: #003049;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 13px;
    cursor: pointer;
    transition: border-color 0.3s ease;
    box-sizing: border-box;
`;

const ScrollContainer = styled.div`
    width: 100%;
    height: auto;
    max-height: 300px !important;
    min-height: 150px !important;
    overflow-y: auto;
    overflow-x: hidden;
    gap: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0%;
    scroll-behavior: smooth;
    padding: 8px 0px 0px 0px;
    border-top: 2px solid #003049;
    justify-content: flex-start;
    box-sizing: border-box;
  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

`;